import React, { Fragment } from 'react';
import Routes from '@app/routing/Router';

import { AppLoadingContextProvider } from '@shared/store/context/AppLoadingContext/AppLoadingContext';
import { SubscribtionContextProvider } from '@shared/store/context/SubscribtionContext';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { setInappRedirect } from '@entities/dcb';
import { useEffect } from 'react';

import '@shared/styles/fonts.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // TODO: if possible tree shake

import '@shared/styles/react-tel-input.css';
import '@shared/styles/App.css';
import '@shared/styles/App2.css';
import '@shared/styles/AppResponsive.css';

import { AppParent } from '@shared/ui/app-parent';

const App = () => {
  useEffect(() => {
    if (window.location.pathname.includes('/inappredirect/')) {
      setInappRedirect(true);
    }
  }, []);

  return (
    <SubscribtionContextProvider>
      <Router basename="/">
        <Fragment>
          <Switch>
            <AppParent>
              <AppLoadingContextProvider>
                <Route component={Routes} />
              </AppLoadingContextProvider>
            </AppParent>
          </Switch>
        </Fragment>
      </Router>
    </SubscribtionContextProvider>
  );
};

export default App;
